import { Button, styled, Theme } from '@mui/material';
import { palette } from 'view/themes/palette';

export const CustomButton = styled(Button)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    minHeight: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    padding: '12px 24px',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '20.48px',
    textTransform: 'none',
    boxShadow: 'none',

    [theme.breakpoints.down('iphone5')]: {
      padding: '12px',
    },

    '> span': {
      margin: '0',
    },

    '&.header-button': {
      width: 'max-content',
      minHeight: '40px',
      padding: '10px 20px',
    },

    '&.hide-button': {
      minWidth: '85px',
      width: 'max-content',
      minHeight: '35px',
      height: 'auto',
      padding: '8px 36px',
    },

    '&.red-button': {
      minWidth: '85px',
      width: 'max-content',
      minHeight: '40px',
      height: 'auto',
      padding: '8px 20px',

      '&.MuiButton-contained': {
        color: palette.alerts.error,
        backgroundColor: palette.alerts.error_light,

        '&:hover': {
          color: palette.white,
          backgroundColor: palette.alerts.error,
          boxShadow: 'none',
        },

        '&:disabled': {
          backgroundColor: palette.alerts.error_light,
          color: palette.white,
          boxShadow: 'none',
          cursor: 'not-allowed',
          opacity: 1,
        },
      },

      '&.MuiButton-outlined': {
        color: palette.alerts.error,
        backgroundColor: palette.alerts.error_light,
        border: 'none',
        borderColor: 'transparent',

        '&:hover': {
          color: palette.white,
          backgroundColor: palette.alerts.error,
          boxShadow: 'none',
        },

        '&:disabled': {
          backgroundColor: palette.alerts.error_light,
          color: palette.white,
          boxShadow: 'none',
          cursor: 'not-allowed',
          opacity: 1,
        },
      },
    },

    '&.MuiButton-contained': {
      color: palette.white,
      backgroundColor: palette.primary.purple500,

      '&:hover': {
        backgroundColor: palette.primary.purple600,
        boxShadow: 'none',
      },

      '&:disabled': {
        backgroundColor: palette.unknown.disabled_grey,
        color: palette.white,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
      },
    },

    '&.hover': {
      '&.MuiButton-outlined': {
        '&:hover': {
          backgroundColor: '#ffeeee',
        },
      },
    },

    '&.MuiButton-outlined': {
      color: palette.primary.purple500,
      backgroundColor: palette.white,
      border: '1px solid',
      borderColor: palette.primary.purple500,

      '&:hover': {
        color: palette.primary.purple600,
        borderColor: palette.primary.purple600,
        backgroundColor: palette.white,
        boxShadow: 'none',
      },

      '&:disabled': {
        backgroundColor: palette.white,
        color: palette.unknown.disabled_grey,
        borderColor: palette.unknown.disabled_grey,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
      },
    },
  };
}) as typeof Button;
